export const QUOTE_SEARCH_INPUT_ID = 'quote-search-input';
export const QUOTE_SEARCH_SUBMIT_ID = 'quote-search-submit';
export const QUOTE_SEARCH_CREATED_BY_FILTER_ID = 'quote-search-created-by-filter';
export const QUOTE_SEARCH_TAGS_FILTER_ID = 'quote-search-tags-filter';
export const QUOTE_SEARCH_ACTIVE_TAB_ID = 'quote-search-active-tab';
export const QUOTE_SEARCH_ARCHIVE_TAB_ID = 'quote-search-archive-tab';
export const QUOTE_SEARCH_TABLE_ID = 'quote-search-table';

export const QUOTE_SEARCH_ITEM_CLASS = 'quote-search-item';
